import '../../resources/css/visual/VirtualDeviceForm.scss';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field, getFormValues, reduxForm} from 'redux-form';
import {Button, Col, Row} from 'react-bootstrap';
import {checkTableAuth} from '../common/access-auth';
import {verifyAngle, verifyForm, maxLength32, validateNull} from '../common/access-form-validation';
import {commonRenderInput, commonRenderSelect} from '../common/access-form';
// import { verifyNumber } from '../../components/common/access-form-validation';
import {closeModal, openModalAlert, openModalTip, openPickModal, popupModalConfirm} from '../../actions/index';
// import Loading from '../../components/common/Loading';
import {doGetAvaliableDeviceData, doSaveVirtualDeviceInfo} from '../../actions/visual';
import {Dropdown, Space, Typography} from 'antd';
import {DownOutlined} from '@ant-design/icons';
import _ from 'lodash';


// const devicePlacementOptions = ["supine", "prone", "standing", "lateral"];
// const MI10Txpower2gOptions = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];
// const MI10Txpower5g1Options = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21];
// const MI10Txpower5g2Options = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];
const rangeTxpowerOptions = [10, 25, 50, 75, 100];
let deviceOptions = ['none'];

class VirtualDeviceForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            bindingDevice: null,
            devicePlacement: "supine"
        }
    };


    formSubmit = (values) => {
        const { verifyFormPass, authToken, popupModalConfirm, accountRole, roleTableAuth, doSaveVirtualDeviceInfo, openModalAlert, graphId } = this.props;

        if (checkTableAuth('rf_map', accountRole, roleTableAuth, 2)) {
            if (verifyFormPass) {
                
                values.deviceMac = this.state.bindingDevice === 'none' ? null : this.state.bindingDevice;
                values.devicePlacement = this.state.devicePlacement;
                
                popupModalConfirm('Confirm', 'icon-alert', 'Confirm to save?', 300, () => doSaveVirtualDeviceInfo(authToken, values, graphId), null, false);

            } else {
                openModalAlert("Sorry, field need to fill.");
            }

        } else {
            openModalAlert("Sorry you don't have permission to change config.");
        }
    }

    changeDevicePlacementList = (e) => {
        const { change } = this.props;
        this.setState({devicePlacement: e.key})
        change('devicePlacement', e.key);
    }

    changePowerDbm2g = (e) => {
        const { change } = this.props;
        change('powerDbm2g', parseInt(e.target.value));
    }

    changePowerDbm5g1 = (e) => {
        const { change } = this.props;
        change('powerDbm5g1', parseInt(e.target.value));
    }

    changePowerDbm5g2 = (e) => {
        const { change } = this.props;
        change('powerDbm5g2', parseInt(e.target.value));
    }

    changePowerDbm6g = (e) => {
        const { change } = this.props;
        change('powerDbm6g', parseInt(e.target.value));
    }

    changeBindingDevice = (e) => {
        const { change } = this.props;
        this.setState({bindingDevice: e.key})
        change('deviceMac', e.key);
    }

    loadData = () => {
        const { change, data, scaleWindow } = this.props;
        // const { deviceOptions } = this.state;
        if (data) {
            change('name', data.name);
            change('rotationAngle',  String(data.rotationAngle));
            change('devicePlacement', data.devicePlacement);
            change('powerDbm2g', data.powerDbm[0] !== 0 ? data.powerDbm[0] : 100);
            change('powerDbm5g1', data.powerDbm[1] !== 0 ? data.powerDbm[1] : 100);
            change('powerDbm5g2', data.powerDbm[2] !== 0 ? data.powerDbm[2] : 0);
            change('powerDbm6g', data.powerDbm[3] !== 0 ? data.powerDbm[3] : 0);
            change('modelName', data.modelName);
            change('x', data.x / scaleWindow);
            change('y', data.y / scaleWindow);
            change('site', data.site);
            change('group', data.group);
            change('deviceMac', data?.deviceMac ?? 'none');
            change('seq', data?.seq);
        }

    }

    displayPlacement = () => {
        return [
            {
                key: 'supine',
                label: 'supine' 
            },
            {
                key: 'prone',
                label: 'prone' 
            },
            {
                key: 'standing',
                label: 'standing' 
            },
            {
                key: 'lateral',
                label: 'lateral' 
            }
        ]
    }

    displayPhysicalDeviceItem = () => {
        const { accountInfo, accountRole, deviceList } = this.props

        let groupId = accountInfo.groupId;

        let result = _.groupBy(deviceList, 'group');
        let defaultNone =  {
            key: 'none',
            label: 'none'
        }
        // console.log(result)
        let itemResult = [];
        itemResult.push(defaultNone)

        Object.entries(result).forEach(([key, groupValue]) => {
            // if (groupValue[0].groupName !== undefined) {
                let treeSelect = {
                    key: key,
                    type: 'group',
                    label: groupValue[0].groupName
                }
                let childrenArr = [];
                groupValue.forEach((currentValue) => {
                    let childrenObj = {
                        key: currentValue.mac,
                        label: currentValue.mac + "  |  " + currentValue.name,
                        disabled: !((parseInt(key) === parseInt(groupId)) || accountRole.flagSuperAdmin)
                    }
                    childrenArr.push(childrenObj);
                    // console.log(currentValue)

                })
                treeSelect['children'] = childrenArr;
                itemResult.push(treeSelect);
            // }

        });


        return itemResult;
    }




    componentDidUpdate(prevProps, prevState, snapshot) {
        const { status, data } = this.props;

        if (prevProps.status !== status) {
        }

        const isChangeData = prevProps.data !== data;
        const isChangePosition = prevProps.data?.x !== data?.x || prevProps.data.y !== data?.y;
        const isChangeSeq = prevProps.data?.seq !== data?.seq;

        // call loadData when data change/seq change/Position of virtualDevice change
        if (isChangeData && (isChangePosition || isChangeSeq)) {
            console.log("==========", data.seq)            
            this.loadData();
        }

    }


    componentDidMount() {
        // if call render will do this method
        const { deviceList, data } = this.props;

        deviceOptions = ['none'];
        deviceList.forEach(e => deviceOptions.push(e.mac));
        this.setState({bindingDevice: data.deviceMac ?? 'none', devicePlacement: data.devicePlacement})
        this.loadData();

    }

    render() {
        const { handleSubmit, isReadonly, verifyFormPass, data, autoSize, formValues, closeVirtualModal } = this.props;
        if (deviceOptions.length > 0 && data && formValues) {
            return (
                <div className='area-form form-custom'>
                    <div className='device-virtual-form' style={{ height: autoSize ? 'auto' : '280px' }}>
                        <form onSubmit={handleSubmit(this.formSubmit)}>
                            <div className='area-content area-divide-space'>
                                {/* <div className='area-header'>
                                <span className='icon-internet icon-info'></span><label>Role</label>
                            </div> */}
                                <div className='area-body'>
                                    {/* <Row>
                                        <Col sm={12}>{data?.modelName}</Col>
                                    </Row> */}
                                    <Row>
                                        <Col sm={12} >
                                            <div className='area-form-label' style={{ marginTop: '-15px', marginBottom: '-5px' }}>
                                                Device name
                                            </div>
                                            <div className='area-form-field'>
                                                <Field name='name' type="text" component={commonRenderInput} placeholder="Input here" disabled={isReadonly} validate={[maxLength32, validateNull]}  />
                                            </div>
                                        </Col>

                                        {data?.modelName === "MI10" ?
                                            <><Col sm={4} style={{ marginTop: '-15px' }}>
                                                <div className='area-form-label'>
                                                    <span className='icon-radio-config' />
                                                    2.4 GHz
                                                    <br />
                                                    <span style={{ fontWeight: '300', marginLeft: '20px', fontSize: '10px' }}>Tx Power (%)</span>
                                                </div>
                                                <div className='area-form-field'>
                                                    <Field name="powerDbm2g"
                                                        component={commonRenderSelect}
                                                        options={rangeTxpowerOptions}
                                                        callback={this.changePowerDbm2g}
                                                        disabled={formValues.deviceMac !== 'none'}
                                                    />
                                                </div>
                                            </Col>
                                                <Col sm={4} style={{ marginTop: '-15px' }}>
                                                    <div className='area-form-label'>
                                                        <span className='icon-radio-config' />
                                                        5 GHz(5G-1)
                                                        <br />
                                                        <span style={{ fontWeight: '300', marginLeft: '20px', fontSize: '10px' }}>Tx Power (%)</span>
                                                    </div>
                                                    <div className='area-form-field'>
                                                        <Field name="powerDbm5g1"
                                                            component={commonRenderSelect}
                                                            options={rangeTxpowerOptions}
                                                            callback={this.changePowerDbm5g1}
                                                            disabled={formValues.deviceMac !== 'none'}

                                                        />
                                                    </div>
                                                </Col></>

                                            : <><Col sm={4} style={{ marginTop: '-15px' }}>
                                                <div className='area-form-label'>
                                                    <span className='icon-radio-config' />
                                                    2.4 GHz
                                                    <br />
                                                    <span style={{ fontWeight: '300', marginLeft: '20px', fontSize: '10px' }}>Tx Power (%)</span>
                                                </div>
                                                <div className='area-form-field'>
                                                    <Field name="powerDbm2g"
                                                        component={commonRenderSelect}
                                                        options={rangeTxpowerOptions}
                                                        callback={this.changePowerDbm2g}
                                                        disabled={formValues.deviceMac !== 'none'}

                                                    />
                                                </div>
                                            </Col>
                                                <Col sm={4} style={{ marginTop: '-15px' }}>
                                                    <div className='area-form-label'>
                                                        <span className='icon-radio-config' />
                                                        5 GHz(5G-1)
                                                        <br />
                                                        <span style={{ fontWeight: '300', marginLeft: '20px', fontSize: '10px' }}>Tx Power (%)</span>
                                                    </div>
                                                    <div className='area-form-field'>
                                                        <Field name="powerDbm5g1"
                                                            component={commonRenderSelect}
                                                            options={rangeTxpowerOptions}
                                                            callback={this.changePowerDbm5g1}
                                                            disabled={formValues.deviceMac !== 'none'}

                                                        />
                                                    </div>
                                                </Col></>

                                        }

                                        {data.modelName === "MI10" ? <Col sm={4} style={{ marginTop: '-15px' }}>
                                            <div className='area-form-label'>
                                                <span className='icon-radio-config' />
                                                5 GHz(5G-2)
                                                <br />
                                                <span style={{ fontWeight: '300', marginLeft: '20px', fontSize: '10px' }}>Tx Power (%)</span>
                                            </div>
                                            <div className='area-form-field'>
                                                <Field name="powerDbm5g2"
                                                    component={commonRenderSelect}
                                                    options={rangeTxpowerOptions}
                                                    callback={this.changePowerDbm5g2}
                                                    disabled={formValues.deviceMac !== 'none'}                                               

                                                />
                                            </div>
                                        </Col>
                                            : ''
                                        }

                                        {data.modelName === "MI11" ? <Col sm={4} style={{marginTop: '-15px'}}>
                                                <div className='area-form-label'>
                                                    <span className='icon-radio-config'/>
                                                    6 GHz
                                                    <br/>
                                                    <span style={{ fontWeight: '300', marginLeft: '20px', fontSize: '10px' }}>Tx Power (%)</span>
                                                </div>
                                                <div className='area-form-field'>
                                                    <Field name="powerDbm6g"
                                                           component={commonRenderSelect}
                                                           options={rangeTxpowerOptions}
                                                           callback={this.changePowerDbm6g}
                                                           disabled={formValues.deviceMac !== 'none'}
                                                    />
                                                </div>
                                            </Col>
                                            : ''
                                        }

                                        <Col sm={12} >
                                            <div className='area-form-label' style={{ marginTop: '-15px', marginBottom: '-5px' }}>
                                                Rotation angle
                                            </div>
                                            <div className='area-form-field' >
                                                <Field name='rotationAngle' type="text" component={commonRenderInput} placeholder="Input here" disabled={isReadonly} validate={verifyAngle} />
                                            </div>
                                        </Col>
                                        <Col sm={12} >
                                            <div className='area-form-label' style={{ marginTop: '-15px' }}>
                                                Placement
                                            </div>
                                            <Dropdown overlayStyle={{
                                                    boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.2)',
                                                    border: 'solid 1px rgba(229, 229, 229, 0.6)',
                                                    borderRadius: '10px',
                                                }}
                                                overlayClassName='device-placement'
                                                menu={{
                                                    items: this.displayPlacement(),
                                                    selectable: true,
                                                    defaultSelectedKeys: this.state.devicePlacement,
                                                    onClick: this.changeDevicePlacementList
                                                }}
                                                trigger="click"
                                            >
                                                <Typography.Link>
                                                    <Space>
                                                        {this.state.devicePlacement}
                                                        <DownOutlined />
                                                    </Space>
                                                </Typography.Link>
                                            </Dropdown>
                                        </Col>
                                        <br/><br/><br/>
                                        {/* <Col sm={12}>
                                            <div className='area-form-label' style={{ marginTop: '-15px' }}>
                                                Device Binding
                                            </div>
                                            <Dropdown overlayStyle={{
                                                    maxHeight: '200px',
                                                    overflowY: 'scroll',
                                                    boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.2)',
                                                    border: 'solid 1px rgba(229, 229, 229, 0.6)',
                                                    borderRadius: '10px'
                                                }}
                                                menu={{
                                                    items: this.displayPhysicalDeviceItem(),
                                                    selectable: true,
                                                    defaultSelectedKeys: this.state.bindingDevice ?? 'none',
                                                    onClick: this.changeBindingDevice
                                                }}
                                                trigger="click"
                                            >
                                                <Typography.Link>
                                                    <Space>
                                                        {this.state.bindingDevice}
                                                        <DownOutlined />
                                                    </Space>
                                                </Typography.Link>
                                            </Dropdown>
                                        </Col> */}


                                    </Row>
                                </div>
                            </div>

                            <br/>

                            <div className='area-btns'>
                                <Row>
                                    <Button variant="primary" size="lg" bsPrefix='btn-cancel' onClick={()=> closeVirtualModal()}>
                                        Cancel
                                    </Button>
                                    <Button type="submit" variant="primary" bsPrefix='btn-save' size="lg" disabled={!verifyFormPass}>
                                        Save
                                    </Button>
                                </Row>
                            </div>
                        </form>
                    </div>
                </div>
            )
        } else { return (<></>) }
    }
}

const getverifyField = () => {
    return ['name', 'rotationAngle']
}

const mapStateToProps = (state) => {
    const verifyFormPass = verifyForm(state.form['VirtualDeviceForm'], getverifyField());

    return {
        authToken: state.loginReducers.authToken,
        accountRole: state.loginReducers.accountRole,
        accountInfo: state.loginReducers.accountInfo,
        roleTableAuth: state.loginReducers.roleTableAuth,
        loading: state.settingsReducers.loading,
        status: state.visualReducers.status,
        modalPick: state.commonReducers.modalPick,
        selectRole: state.settingsReducers.selectRole,
        roleDetail: state.settingsReducers.roleDetail,
        errMsg: state.settingsReducers.errMsg,
        selectSite: state.siteReducers.selectSite,
        deviceList: state.visualReducers.deviceList,
        mappingOrg: state.visualReducers.mappingOrg,
        initialValues: {},
        verifyFormPass: verifyFormPass,
        formValues: getFormValues('VirtualDeviceForm')(state),
    };
}

VirtualDeviceForm = reduxForm({
    form: 'VirtualDeviceForm',  // a unique identifier for this form
})(VirtualDeviceForm)

export default connect(
    mapStateToProps,
    { closeModal, popupModalConfirm, openPickModal, openModalAlert, openModalTip, doSaveVirtualDeviceInfo, doGetAvaliableDeviceData }
)(VirtualDeviceForm)